<template>
  <div class="section" :class="pageClass">
    <!-- 测试者个人分析报告【首页】 -->
    <img :src="images.logo" style="
        height: auto;
        width: 20%;
        float: right;
        margin-right: 50px;
        margin-top: 30px;
      " />
    <div style="margin-left: 290px; padding-top: 170px">
      <p
        align="center"
        style="text-align: center; font-size: 33pt; color: white; padding: 10px"
      >
        <b v-if="isTeam == false">{{ this.model.report_type == '3' ? "&nbsp;" : this.model.report_type }}</b>
        <b v-if="isTeam == true">{{ this.report_type == '3' ? "&nbsp;" : this.model.report_type }}</b>
      </p>
      <p align="center" style="
          text-align: center;
          font-size: 33pt;
          color: white;
          padding: 0 10px 10px 10px;
        ">
        <b v-if="isPsychology == true">心理健康状态测验</b>
        <b v-if="isPersonality == true">人格特质测验</b>
        <b v-if="isTeam == true">团队角色测验</b>
        <b v-if="isBehavior == true">岗位胜任力测验</b>
      </p>
      <p align="center" style="text-align: center; font-size: 33pt; color: white">
        <b>个人分析报告</b>
      </p>
    </div>

    <!-- 必填基础信息 - 名字、性别、年龄 -->
    <div class="base_info">
      <p class="fbt" v-if="isPsychology == true || isBehavior == true">
        {{ this.model.realName }}
      </p>
      <p class="fbt" v-if="isPersonality == true">
        {{ this.model.name }}
      </p>
      <p class="fbt" v-if="isTeam == true">
        {{ this.model.realName || "未填写名字" }}
      </p>

      <p style="font-size: 17pt; margin-top: 15px; font-weight: 600">
        <span style="margin-right: 30px">{{
          this.model.gender || "性别未知"
        }}</span>
        <el-divider direction="vertical"></el-divider>
        <span style="margin-left: 20px" v-if="this.model.age">
          {{ this.model.age }}岁</span>
        <span style="margin-left: 20px" v-else> 年龄不详</span>
      </p>
    </div>

    <!-- 选填项  -->
    <div class="more_info">
      <table width="150" height="272" style="width: 400pt; border-collapse: separate; border-spacing: 30px">
        <tbody>
          <tr v-if="this.score != ''">
            <td style="
                font-size: 14pt;
                color: #6e736e;
                font-weight: bold;
                width: 100px;
              ">
              风险评估
            </td>
            <td style="font-size: 15pt; font-weight: bold">
              <el-rate style="margin-top: -10px" v-model="value" disabled :colors="colors" :texts="texts"
                text-color="black" show-text>
              </el-rate>
            </td>
          </tr>

          <tr v-if="this.score100 != ''">
            <td style="
                font-size: 14pt;
                color: #6e736e;
                font-weight: bold;
                width: 100px;
              ">
              成绩
            </td>
            <td style="
                font-size: 17pt;
                font-weight: bold;
                max-width: 300px;
                overflow: hidden;
                text-overflow: ellipsis;
                text-algin: left;">
              {{ score100 }}
            </td>
          </tr>

          <!-- 此处排版要按5个元素的高度设置 -->
          <tr v-for="(item, index) in this.infoList" :key="index">
            <td style="
                font-size: 14pt;
                color: #6e736e;
                font-weight: bold;
                width: 100px;
              ">
              <div>
                {{ item.name }}
              </div>
            </td>
            <td style="
                font-size: 17pt;
                font-weight: bold;
                max-width: 300px;
                overflow: hidden;
                text-overflow: ellipsis;
                text-algin: left;
              ">
              <div>
                {{ item.value }}
              </div>
            </td>
          </tr>
          <tr class="email" v-if="email">
            <td class="trLeft">
                <div>
                    邮箱
                </div>
            </td>
            <td class="trRight">
                <email-model :email="email" :guid="guid" :privacyType="privacyType"></email-model>
            </td>
          </tr>
          <tr class="Mobile" v-if="mobile">
            <td class="trLeft">
                <div>
                    电话
                </div>
            </td>
            <td class="trRight">
                <mobile-model v-if="mobile" :mobile="mobile" :guid="guid" :privacyType="privacyType"></mobile-model>
            </td>
          </tr>
          <tr class="idcard" v-if="idcard">
            <td class="trLeft">
                <div>
                    身份证号码
                </div>
            </td>
            <td class="trRight">
                <id-card-model v-if="idcard" :idcard="idcard" :guid="guid" :privacyType="privacyType"></id-card-model>
            </td>
          </tr>
          <tr>
            <td style="
                font-size: 14pt;
                color: #6e736e;
                font-weight: bold;
                width: 100px;
              ">
              测评日期
            </td>
            <td style="font-size: 17pt; font-weight: bold">
              <span v-if="isTeam == false">{{ this.model.report_time }}</span>
              <span v-if="isTeam == true">{{ this.time }}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <!-- 声明 -->
    <div class="statement">
      <div v-html="statement"></div>
    </div>
  </div>
</template>

<script>
import { personalInfo } from "@/views/report/config/three";
import EmailModel from '../components/email-model.vue'
import MobileModel from '../components/mobile-model.vue'
import IdCardModel from '../components/idcard-model.vue'

// import moment from "moment";
export default {
  components: {
    EmailModel,
    MobileModel,
    IdCardModel
  },
  props: [
    "model",
    "score",
    "score100",
    "isPersonality",
    "isPsychology",
    "isTeam",
    "isBehavior",
    "time",
    "info",
    "report_type",
    "guid",
    "privacyType"
  ],
  data() {
    return {
      infoList: [],
      images: {
        logo: require("../../../assets/images/page1/logo.png"),
      },
      texts: ["风险很高", "风险较高", "风险一般", "风险较低", "风险很低"],
      colors: ["#26BCB8", "#26BCB8", "#26BCB8"],
      statement: personalInfo.statement,
      value: 0,
      data: "",
      isPdf: false,

      email: '',
      mobile: '',
      idcard: '',
      pageClass: ''
    };
  },
  mounted() {
    if (this.score) {
      this.value = this.score / 2;
    }
    if (location.hash.indexOf('pdf') > -1) {
      this.isPdf = true
    }
    this.pageClass = location.hash.substring(location.hash.lastIndexOf("/") + 1);
  },
  watch: {
    score(val) {
      this.value = val || 0;
    },
    info(val) {
      if (val && val.length > 0) {
        this.infoList = []
        let _this = this;
        this.info.forEach(function (item) {
          if (item.name == '邮箱') {
            _this.email = item.value
          }
          else if (item.name == '电话') {
            _this.mobile = item.value
          }
          else if (item.name == '身份证号码') {
            _this.idcard = item.value
          }
          else { 
            _this.infoList.push(item)
          }
        })
      }
      else { 
        this.infoList = []
      }
    },
  },
  methods: {
    // getYMDHMS(timestamp) {
    //   let time = new Date(timestamp);
    //   return moment(time).format("YYYY-MM-DD");
    // },
  },
};
</script>

<style lang="scss" scoped>
.section {
  page-break-before: always;
  page-break-after: always;
  page-break-inside: avoid;
  background-size: cover;
  background-image: url("../../../assets/images/page1/background.png");
  height: 1124px;
  overflow: hidden;
}
.fbt{
  font-size: 40px; margin-top: 60px; font-weight: bold
}

.base_info {
  margin-left: 100px;
}

.more_info {
  margin-top: 80px;
  margin-left: 70px;
  min-height: 391px;
}

.behavior {
  .more_info {
    margin-top: 50px;
  }
  .base_info {
    .fbt {
      margin-top: 50px;
    }
  }
}

.statement {
  padding: 30px 60px 30px 60px;
  color: #6e736e;
  font-size: 16.5px;
  line-height: 24px;
}
.trLeft {
    font-size: 14pt;
    color: #6e736e;
    font-weight: bold;
    width: 100px;
}

.trRight {
    font-size: 17pt;
    font-weight: bold;
    max-width: 300px;
    overflow: hidden;
    text-overflow: ellipsis;
    text-algin: left;
}
</style>



// WEBPACK FOOTER //
// src/views/report/three/pageOne.vue